module.exports = __webpack_public_path__ + "static/media/es.c3853709.svg";